/* eslint-disable camelcase */
import { apiDescargaDirigidaPost } from "../../api/descargas";
import { homologaNumeroPedimento } from "../../common/pedimentos/utils";
import { getMaterialHijoEnDescarga, getMaterialPadreEnDescarga } from "./common";
import {
    dataTableDescarga,
    dataTableDetalle,
    dataTablePedimentos,
    freezeAllDataTables,
    mostrarDetallePedimentoSeleccionado,
} from "./dataTables";
import {
    columnsWithDesp,
    columnsWithoutDesp,
    simulacionDescargaDataTable,
} from "./dataTables/DataTableDescargaSimulacion";
import { alertDescargaOk } from "./descarga.alerts";
import { actualizarDataTables } from "./descarga.confirmar";
import { DESCARGO_UNO_A_UNO, DescargaCommonGlobal } from "./descarga.global";
import { getContenedoresImportacion, getPedimentoParaDescargar, verificaSinFechaVencimiento } from "./utils";
import {
    btnCancelaDescargo,
    btnDescarga,
    btnSiguienteMaterial,
    disabledBusquedaPedimentos,
    headerPedimentoDataTable,
    modalSimulacionTituloElement,
} from "./view";

/**
 * Inicializa y comienza con el proceso de descarga
 */
export const initProcesoDescarga = async () => {
    freezeAllDataTables();

    disabledBusquedaPedimentos();

    btnDescarga.disabled = true;

    DescargaCommonGlobal.enProceso = true;
    DescargaCommonGlobal.enDescarga.tipo = DESCARGO_UNO_A_UNO;
    DescargaCommonGlobal.contenedoresImportacionParaDescargar = [];

    const pedimentoExportacionSeleccionado = getPedimentoParaDescargar();
    delete pedimentoExportacionSeleccionado["item-selected"];

    dataTablePedimentos.options.data = [];
    dataTablePedimentos.refresh();

    dataTableDetalle.options.data = [];
    dataTableDetalle.refresh();

    headerPedimentoDataTable.previousElementSibling.innerHTML = "Pedimento de exportación";
    headerPedimentoDataTable.innerHTML = "";

    const { pedimento_id: pedimentoId } = pedimentoExportacionSeleccionado;

    const pedimentoExportacionData = DescargaCommonGlobal.pedimentosExportacionValidos[pedimentoId];

    pedimentoExportacionData.detalle = pedimentoExportacionData.detalle.map((itm) => ({
        ...itm,
        contenedor_id: itm.id,
        cantidadPorDescargar: itm.cantidad,
        uuid: uuidv4(),
    }));

    const { detalle } = pedimentoExportacionData;

    DescargaCommonGlobal.enDescarga.pedimentoId = pedimentoId;
    DescargaCommonGlobal.enDescarga.materialesPadre = detalle;

    const detalleEnDescarga = detalle[0];
    DescargaCommonGlobal.enDescarga.padreId = detalleEnDescarga.uuid;
    const respuestaContenedoresImportacion = await getContenedoresImportacion([detalleEnDescarga.material]);

    DescargaCommonGlobal.contenedoresImportacionParaDescargar = [
        ...respuestaContenedoresImportacion.simulacion_descarga,
    ];

    verificaSinFechaVencimiento(respuestaContenedoresImportacion.sin_fecha_vencimiento);

    dataTablePedimentos.options.data = [pedimentoExportacionSeleccionado];
    dataTablePedimentos.refresh();

    mostrarDetallePedimentoSeleccionado(pedimentoId);

    btnSiguienteMaterial.classList.remove("d-none");
    btnSiguienteMaterial.disabled = false;

    btnCancelaDescargo.classList.remove("d-none");
    btnCancelaDescargo.disabled = false;

    btnDescarga.disabled = false;
    btnDescarga.innerHTML = '<i class="fas fa-exclamation-circle"></i>&ensp;Iniciar descarga';

    freezeAllDataTables(false);
};

/**
 * Realiza la descarga de mercancías con las opciones seleccionadas
 * @param {boolean} simulacion
 */
export const handleProcesarDescarga = async (simulacion = true) => {
    const materialPadreEnDescarga = getMaterialPadreEnDescarga();
    let isOnlyDesperdicio = true;

    const descargaRequest = {
        simulacion,
        contenedores_impo: [],
        contenedor_expo: materialPadreEnDescarga.contenedor_id,
        pedimento_expo_id: materialPadreEnDescarga.pedimento_id,
        porcentaje_desperdicio: 0,
        porcentaje_merma: 0,
    };

    if (DescargaCommonGlobal.enDescarga.tipo === DESCARGO_UNO_A_UNO) {
        descargaRequest.cantidad_expo = materialPadreEnDescarga.cantidad;
    } else {
        const materialHijoEnDescarga = getMaterialHijoEnDescarga(materialPadreEnDescarga);

        descargaRequest.cantidad_expo = materialHijoEnDescarga.cantidadPorDescargar;
        descargaRequest.porcentaje_desperdicio = materialHijoEnDescarga.porcentaje_desperdicio;
        descargaRequest.porcentaje_merma = materialHijoEnDescarga.porcentaje_merma;
    }

    const checkedRowsDataTableDescarga = dataTableDescarga.rowmanager.getCheckedRows();

    descargaRequest.contenedores_impo = checkedRowsDataTableDescarga
        .filter((indice) => {
            const existe = DescargaCommonGlobal.contenedoresImportacionValidadosParaDescarga.findIndex(
                (itm, index) => index === Number(indice),
            );
            return existe > -1;
        })
        .map((indice) => {
            const contenedorValidado = DescargaCommonGlobal.contenedoresImportacionValidadosParaDescarga[indice];

            if (isOnlyDesperdicio && !contenedorValidado.isDesperdicio) isOnlyDesperdicio = false;

            return {
                contenedor_impo_id: contenedorValidado.contenedor_id,
                material: contenedorValidado.material,
                cantidad_impo: contenedorValidado.cantidad,
                cantidad_utilizar: contenedorValidado.cantidad_utilizar,
                isDesperdicio: contenedorValidado.isDesperdicio,
            };
        });

    const { descarga: descargaResponse, cantidadExportacionPendientePorDescargar } = await apiDescargaDirigidaPost(
        descargaRequest,
    );

    const simulacionResponseDataTable = descargaResponse.map((itm) => ({
        ...itm,
        pedimento_formato: homologaNumeroPedimento({
            fechaPagoReal: itm.fecha_pago_real,
            seccion: itm.seccion_aduanera,
            patente: itm.patente,
            pedimento: itm.numero_pedimento,
            isDesperdicio: itm.es_desperdicio,
        }),
    }));

    simulacionDescargaDataTable.options.data = simulacionResponseDataTable;
    simulacionDescargaDataTable.options.columns = columnsWithDesp;
    if (isOnlyDesperdicio) simulacionDescargaDataTable.options.columns = columnsWithoutDesp;
    simulacionDescargaDataTable.refresh();

    const pedimentoExportacionSplit = DescargaCommonGlobal.pedimentosExportacionValidos[
        descargaRequest.pedimento_expo_id
    ].pedimento_formato.split("-");
    const pedimentoExportacion = pedimentoExportacionSplit[0];

    if (simulacion) {
        modalSimulacionTituloElement.innerHTML = `
            Descarga del pedimento de exportación: <strong>${pedimentoExportacion}</strong>
        `;

        $("#modal-simulacion-descarga").modal("show");
    } else {
        $("#modal-simulacion-descarga").modal("hide");

        alertDescargaOk().then(() => {
            actualizarDataTables(descargaResponse, cantidadExportacionPendientePorDescargar);
        });
    }
};
